<template>
  <div class="app-management-swiper">
    <div class="swiper-container management">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in managementList">
          <div class="management-show">
            <img class="managementImg" :src="item.imgUrl" alt="" />
            <p><span>{{item.name}}</span>{{item.duty}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="content">
        {{managementContent}}
      </div>
      <div class="manifesto">
        {{managementManifesto}}
      </div>
    </div>
  </div>
</template>
<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  export default {
    name: 'BannerSwiper',
    data() {
      return {
        managementContent:'',
        managementManifesto:''
      };
    },
    props: {
      managementList: Array
    },
    computed: {},
    components: {},
    methods: {
      updateActiveItem: function (index) {
        this.managementContent = this.managementList[index].content;
        this.managementManifesto = this.managementList[index].manifesto;
      },
      managementSwiper: function () {
        this.managementSwiper = new Swiper('.management', {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 0,
          centeredSlides: true,
          effect: 'coverflow',
          coverflow: {
            rotate: 0,
            stretch: 0,
            depth: 160,
            modifier: 1,
            slideShadows: false
          },
          onTransitionEnd: (swiper) => {
            let index = swiper.activeIndex;
            this.updateActiveItem(index);
          }
        });
      }
    },
    created: function () {
    },
    mounted: function () {
      this.managementSwiper();
    }
  };
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-management-swiper {
    padding:0 0.3rem;
    .swiper-container {
      .swiper-wrapper {
        .managementImg {
          width: 100%;
        }
      }
      .swiper-slide {
        width: 2.2rem;
        text-align: center;
        .management-show{
          cursor: pointer;
          position: relative;
          z-index:2;
          border: 1px solid #fbedcf;
          background: $color-4;
          .managementImg {
            width:100%;
          }
          p{
            height:0.9rem;
            color:$color-1;
            font-size:0.16rem;
            padding:0.1rem 0;
            span{
              color:#ffc63d;
            }
          }
        }
        .management-hover{
          position: relative;
          z-index:1;
          cursor: pointer;
          display: none;
          opacity:0;
          .managementImg {
            width:100%;
          }
          p{
            height:0.9rem;
            color:$color-1;
            font-size:0.3rem;
            padding:0.1rem 0;
            span{
              color:#ffc63d;
            }
          }
        }
      }
    }
    .content-box{
      /*height:2.8rem;*/
      .content{
        font-size:0.25rem;
        color:#555555;
        text-align: justify;
        margin-top:0.2rem;
      }
      .manifesto{
        font-size:0.25rem;
        color:#555555;
        text-align: justify;
        margin-top:0.2rem;
        padding-bottom:0.4rem;
      }
    }
  }
</style>
